import Dictservice from './basic/DictService'
import BasicService from './basic/BasicService'
import ResourceService from './basic/ResourceService'
import FileService from './basic/BscFileInfoService'
import RoleService from './basic/RoleService'
import UserService from './basic/UserService'
import RedisService from './basic/RedisService'
import UserAuthService from './basic/UserAuthService'
import UserCare from "./guanhuai/UserCare"
import MuBiao from "./guanhuai/MuBiao"
import BscClueManage from "./guanhuai/BscClueManage";
import BscClueZhaoBiao from "./guanhuai/BscClueZhaoBiao";
import BscClueOnlineMatrix from "./guanhuai/onlineMatrix/BscClueOnlineMatrix";
import BscPalletDealer from "./guanhuai/onlineMatrix/BscPalletDealer";
import grabOrderApi from "./MsgFunnel/grabOrderApi";
import annualTargetApi from "./guanhuai/annualTargetApi"
import netApi from "./guanhuai/netApi"
import createMonthGoal from "./guanhuai/createMonthGoal"
import RiqPingj from "./guanhuai/RiqPingj"
import DailyDemand from "./guanhuai/DailyDemand"
import DailyPlan from "./guanhuai/DailyPlan"
import DaKaJiLu from "./guanhuai/DaKaJiLu"
import moneyBackDomesticService from "./loud/moneyback/moneyBackDomesticService";
import moneyBackforeignService from "./loud/moneyback/moneyBackforeignService";
import pingshen from './loud/yuce/pingshenService'
import UserDemand from "./xuqiu/UserDemand"
import moneyBackClaimService from "./loud/moneyback/moneyBackClaimService";
import OrderService from './dingd/Dingd'
import OrderMainService from './dingd/Dingdmain'
import SecondOrderMainService from './dingd/SecondDingdmain'

import ProService from './loud/xiangmu/proMain'
import Product from './formula/Product'
import jianjie from './loud/yuce/jianjieService'
import LoginService from "./LoginService"
import ResetPassService from "./ResetPassService"
import zongbu from './loud/yuce/zongbuService'
import waixiao from './loud/yuce/waixiaoService'
import wxhuizong from './loud/yuce/wxhuizongService'
import SignService from "./SignService"
import Custcash from "./loud/fanli/Custcash"
import fanli from "./loud/fanli/fanli"
import chanpin from "./dingd/Chanpin"
import batchModifyManager from "./chanpin/batchModifyManager"
import bom from "./dingd/Bom"
import salesList from "./loud/fanli/salesList"
import salesListF from "./loud/fanli/salesListF"
import salesListSh from "./loud/fanli/salesListSh"
import salesListFw from "./loud/fanli/salesListFw"
import ProductLevel from "./loud/fanli/ProductLevel"
import customer from "./loud/fanli/customer"
import xietongguanli from "./guanhuai/xietongguanli"
import riqingRep from "./guanhuai/riqingRep"
import targetProject from "./guanhuai/targetProject"
import nxAddress from "./dingd/nxAddress"
// import Formula from "./formula/Formula"
// import FormulaManager from "./formula/Manager"
// import projectMain from "./formula/Project"
// import Product from "./formula/Product"
// import Marpro from "./formula/Marpro"
// import MarMain from "./formula/MarMain"
// import MarPrice from "./formula/MarPrice"
import FormulaNew from "./formula/FormulaNew"
import FormulaHaiwai from "./formula/FormulaHaiwai"
import FormulaZulin from "./formula/FormulaZulin"
import Competitors from "./loud/jingpin/Competitors"
import CompetitorsManager from "./loud/jingpin/CompetitorsManager"
import jingpinVw from "./loud/jingpin/jingpinVw"
import tejiaVw from "./loud/tejia/tejiaVw"
import specialController from "./loud/tejia/specialController"
import xinzengtejianew from "./loud/tejia/xinzengtejianew"
import lkService from "./loud/tejia/lkService"
import contractService from './loud/hetong/hetong'
import claimRecord from './loud/hetong/claimRecord'
import firstPageService from './loud/firstPage/firstPage'
import loud from './loud/loud/loudService'
import loudnew from './loud/loudnew/loudNewService'
import orderCgService from './dingd/Cgdingd'
import costService from "./loud/cost/costService"
import costDetailService from "./loud/cost/costDetailService"
import costDataService from "./loud/cost/costDataService"
import specialOfferService from "./loud/cost/specialOfferService"
import paodong from './loud/paodong/paodongService'
import highseas from './loud/partnerhighseas/partnerhighseas'
import bscHhptAgentType from './loud/platformConfig/bscHhptAgentType'
import bscHhptInventoryReport from './loud/inventoryReport/bscHhptInventoryReport'
import bscHhptInventoryRecord from './loud/inventoryReport/bscHhptInventoryRecord'
import jihui from './loud/loud/jihuiService'
import cpjh from './loud/loud/chanpinService'
import jiediao from './loud/yuce/jiediaoshenheService'
import inventory from './loud/yuce/inventory'

import wuliaoselect from './formula/MarSelect'
//流程相关start
import prodefservice from './process/ProdefService'
import proinstservice from './process/ProInstService'
import taskservice from './taskservice'
//流程相关end
//消息相关start
import messageService from './basic/messageService'
//消息相关end
import selectUserAgent from './select/ViewUserAgent'
//日志
import operationService from './operation/operationService'
import leaveService from "./leaveoffice/leaveofficeService"
//周预测-》市场预测
import MarketForecast from './weekforecast/MarketForecast';
//周预测-》生产预测
import ProductionForecast from './weekforecast/ProductionForecast';
//季度抢单-客户
import grabOrderCust from "./MsgFunnel/grabOrderCust";
//付款
import invoiceApplyList from "./invoice/applyList";
//资源池
import resourcePool from "./loud/resourcePool/resourcePool";

//显示平台报表
import xsptReport from "./loud/xsptReport/xsptReport.js";
//外销工艺审核人
import specificGy from "./loud/yuce/specificGy.js";

//海外报关主数据
import declaration from "./dingd/declaration"

import supplierAreaService from './dingd/supplierArea'

import companyPrice from './price/companyPrice'

import cgOrderPrice from './price/cgOrderPrice'

import nxAddressKeywords from "./dingd/addrKeywords";
import noticeBoard from "./noticeBoard";

//国科订单
import GKOrderPage from "./dingd/dingdListGK"
import monthlyCollectionList from "./loud/fanli/monthlyCollectionList";

import clueOwner from "./guanhuai/clueOwner";
import clueAgentOwner from "./guanhuai/clueAgentOwner";

import clueIndustryKeyword from "./guanhuai/clueIndustryKeyword";
// 促销活动
import PromotionActivities from "./dingd/PromotionActivities";
// 协同判断
import orderXietong from "./dingd/orderXietong";
//全部导出
export default {
    annualTargetApi,
    Dictservice,
    BasicService,
    UserService,
    RedisService,
    grabOrderApi,
    UserAuthService,
    ResourceService,
    RoleService,
    FileService,
    UserCare,
    MuBiao,
    BscClueManage,
    BscClueZhaoBiao,
    BscClueOnlineMatrix,
    BscPalletDealer,
    netApi,
    createMonthGoal,
    RiqPingj,
    DailyDemand,
    DailyPlan,
    DaKaJiLu,
    moneyBackDomesticService,
    moneyBackforeignService,
    pingshen,
	UserDemand,
    moneyBackClaimService,
    OrderService,
    OrderMainService,
    SecondOrderMainService,
    orderCgService,
    ProService,
    Product,
    jianjie,
    SignService,
    LoginService,
    ResetPassService,
    zongbu,
    waixiao,
    wxhuizong,
    Custcash,
    fanli,
    ProductLevel,
    salesList,
    salesListF,
    salesListSh,
    salesListFw,
    customer,
    // Formula,
    // FormulaManager,
    // projectMain,
    // Product,
    // Marpro,
    // MarMain,
    // MarPrice,
    FormulaNew,
    FormulaHaiwai,
    FormulaZulin,
    Competitors,
    CompetitorsManager,
	contractService,
    claimRecord,
	firstPageService,
    jingpinVw,
    tejiaVw,
    chanpin,
    batchModifyManager,
    bom,
    loud,
    loudnew,
    specialController,
    costService,
    costDetailService,
    costDataService,
    specialOfferService,
    xinzengtejianew,
    lkService,
    paodong,
    highseas,
    bscHhptAgentType,
    bscHhptInventoryReport,
    bscHhptInventoryRecord,
    supplierAreaService,
    jihui,
    cpjh,
    jiediao,

    //选择物料
    wuliaoselect,
    selectUserAgent,
    //流程相关
    prodefservice,
    taskservice,
    proinstservice,
    operationService,
    //消息相关
    messageService,
    //离职相关
    leaveService,
    //库存报表
    inventory,
    //协同管理
    xietongguanli,
    //是否日清报表
    riqingRep,
    //周预测-》市场预测
    MarketForecast,
    //周预测-》生产预测
    ProductionForecast,
    //目标项目管理
    targetProject,
    //季度抢单-客户
    grabOrderCust,
    invoiceApplyList,
    //收货单位管理
    nxAddress,
    //资源池
    resourcePool,
    //报关主数据
    declaration,
    //公司定价
    companyPrice,
    //公司间采购价定价
    cgOrderPrice,

    xsptReport,

    specificGy,
    //用户单位关键字
    nxAddressKeywords,
    noticeBoard,
    GKOrderPage,
    monthlyCollectionList,
    clueOwner,
    clueAgentOwner,
    clueIndustryKeyword,
    // 促销活动
    PromotionActivities,
    //订单协同
    orderXietong
}
